export default {
  reportDefinitions: [],
  reportDefinition: undefined,
};
